export default function PhonePriceCard() {
    const shops = ["shop.ie", "shop.ie", "shop.ie"];

    return (
        <div className="bg-gray-100 rounded-2xl p-6 flex flex-col gap-4 h-fit">
            <h2 className="text-lg font-semibold text-center">from €800 to €1200</h2>

            {shops.map((shop, index) => (
                <div key={index} className="flex justify-between text-sm">
                    <span>{shop}</span>
                    <span>€</span>
                </div>
            ))}

            <button className="text-blue-600 mt-2">Compare Prices</button>
        </div>
    );
}

